import {Component} from "@angular/core";
import {AppRendererComponent} from "../renderer/app.renderer.component";
import {EditFormComponent} from "./edit.form.component";
import {FormComponent} from "../renderer/model/form-component";
import {DynamicComponentBuilder} from "../renderer/dynamic-component-builder.service";
import {MatDialog} from "@angular/material/dialog";
import {SESSION_COMPONENT} from "../renderer/model/dictionary";
import {
    getKeys,
    getOptionByKey,
    getValidatorByKey,
    hasChildren,
    hasOptions,
    hasValidators,
    setOptionForComponentId,
    setValidatorForComponentId
} from "../renderer/model/form-component-utils";

@Component({
    selector: "abstract-editor",
    templateUrl: '../renderer/app.renderer.component.html',
    styleUrls: ['../renderer/app.renderer.component.css'],
})
export class AbstractEditorComponent extends AppRendererComponent {

    constructor(public dynamicFormsBuilderService: DynamicComponentBuilder, public dialog: MatDialog) {
        super();
    }

    private saveFlatMap(component: FormComponent, allFlatComponents : Map<string, FormComponent>) {
        allFlatComponents.set(component.id, component);
        if (hasChildren(component)) {
            component.components.forEach(comp => this.saveFlatMap(comp, allFlatComponents));
        }
        console.log('all flat components:')
        console.dir(allFlatComponents);
    }

    private getComponentById(id: string): FormComponent {
        let allFlatComponents : Map<string, FormComponent> = new Map<string, FormComponent>();
        this.saveFlatMap(this.component, allFlatComponents);
        return allFlatComponents.get(id);
    }

    edit(id: string): void {
        console.log(' EDIT ' + id);
        const loadedFormComponent = this.getComponentById(id);
        console.dir(loadedFormComponent);

        const dialogRef = this.dialog.open(EditFormComponent, {
            width: '80%',
            height: '80%',
            data: loadedFormComponent
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
            console.log(result);
            if (result) {
                console.log('hasValidators : ' + hasValidators(result));
                console.log('hasOptions : ' + hasOptions(result));
                loadedFormComponent.id = (<FormComponent>result).id;
                loadedFormComponent.label = (<FormComponent>result).label;
                if (hasValidators(result)) {
                    console.log('validators .........');
                    console.dir(result.validators);
                    console.log(getKeys(result.validators));
                    getKeys(result.validators).forEach(key => {
                        const value = getValidatorByKey(result, key, undefined);
                        console.log('Validator key:' + key + ', ' + value + ' component.id:' + result.id);
                        setValidatorForComponentId(this.component, result.id, key, value);
                    });
                }

                if (hasOptions(result)) {
                    console.log('options .........');
                    console.dir(result.options);
                    console.log(getKeys(result.options));
                    getKeys(result.options).forEach(key => {
                        const value = getOptionByKey(result, key, undefined);
                        console.log('Option key:' + key + ', ' + value + ' component.id:' + result.id);
                        setOptionForComponentId(this.component, result.id, key, value);
                    });
                }
                this.reload();
            }
        });
    }

    delete(id: string): void {
        console.log('Delete: '+ id);
        this.component.components.forEach(c => { if (c.id===id) {
            console.log('Deleting');
            const selectedComponentIndex = this.component.components.indexOf(c);
            this.component.components.splice(selectedComponentIndex, 1);
        }});
        this.reload();
    }

    reload(): void {
        this.publishChanges();
        window.location.reload();
    }

    publishChanges() {
        let stringComponent = JSON.stringify(this.component, null, 2);
        sessionStorage.setItem(SESSION_COMPONENT, stringComponent);
        console.log('just updated sessionStorage now');
        //this.dynamicFormsBuilderService.rebuild(this.component, this.data, new FormGroup({}));
    }

    // from here : UP & DOWN operations

    goUp(id: string) {
        this.recursiveGoUp(this.component, id);
        this.reload();
    }

    goDown(id: string) {
        this.recursiveGoDown(this.component, id);
        this.reload();
    }

    private recursiveGoUp(component: FormComponent, id: string) {
        component.components.forEach(c => {
            if (c.id === id) {
                const currentIndex = component.components.indexOf(c);
                console.log(currentIndex + ' for id: ' + id + ', ' + c.id);
                // the first is index = 0
                if (currentIndex === 0) {
                    console.log('This is the first');
                } else {
                    const tmp = component.components[currentIndex-1];
                    component.components[currentIndex-1] = c;
                    component.components[currentIndex] = tmp;
                }
            } else {
                if (hasChildren(c)) {
                    this.recursiveGoUp(c, id);
                }
            }
        });
    }

    private recursiveGoDown(component: FormComponent, id: string) {
        let i: number = 0;

        if (hasChildren(component)) {
            while (i < component.components.length) {
                const c = component.components[i];
                if (c.id === id) {
                    const currentIndex = component.components.indexOf(c);
                    console.log(currentIndex + ' for id: ' + id + ', ' + c.id);
                    // the first is index = 0
                    if ((currentIndex + 1) === component.components.length) {
                        console.log('This is the last');
                    } else {
                        const tmp = component.components[currentIndex + 1];
                        component.components[currentIndex + 1] = c;
                        component.components[currentIndex] = tmp;
                        console.log('move ' + currentIndex + ' to ' + (currentIndex + 1));
                        return;
                    }
                }
                i++;
            }
            component.components.forEach(c => {
                if (c.components) {
                    this.recursiveGoDown(c, id);
                }
            });
        }
    }

}
